export const interestsList = [
	'golf',
	'handball',
	'football',
	'classicalMusic',
	'popRock',
	'cultureAndArts',
	'economyAndFinance',
	'cycling',
	'outdoor'
];

export const SELECTED = interestsList.reduce(
	(map: any, key) => {
		map[key] = false;
		return map;
	},
	{ allowStoring: false }
);
